import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { stateActions } from '@/stores/action/home.action';
import HistoryItem from './HistoryItem';
import TabHistory from './TabHistory';
import { getLocaleWordContent } from '@/utils/language.util';

function History({ history, StateActions }) {
    const [tab, setTab] = useState(0);
    const [list, setList] = useState([]);
    const fetchBusinesses = () => {
        StateActions.getBuyState({ state: 'all' });
    };
    useEffect(fetchBusinesses, []);
    const getList = () => {
        setList(history.toJS().orders);
    };

    useEffect(getList, [history]);
    return (
        <>
            <TabHistory tab={tab} setTab={setTab} />
            <div className="history_box history_box01 t_pink">
                <div className="table_body">
                    <table>
                        <thead>
                            <tr>
                                <th>No</th>
                                <th>{getLocaleWordContent('상품이름')}</th>
                                <th>{getLocaleWordContent('날짜')}</th>
                                <th>{getLocaleWordContent('구매취소')}</th>
                            </tr>
                        </thead>

                        <tbody>
                            {tab === 0
                                ? list &&
                                  list.map((item, index) => (
                                      <HistoryItem key={index} no={index + 1} item={item} StateActions={StateActions} />
                                  ))
                                : list &&
                                  list
                                      ?.filter((it) => Number(it.p_no) === tab)
                                      .map((item, index) => (
                                          <HistoryItem
                                              key={index}
                                              no={index + 1}
                                              item={item}
                                              StateActions={StateActions}
                                          />
                                      ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
}
export default connect(
    (state) => ({
        history: state.home.getIn(['myproduct', 'buy']),
    }),
    (dispatch) => ({
        StateActions: bindActionCreators(stateActions, dispatch),
    }),
)(History);
